module.exports = __webpack_public_path__ + "img/room.4eaf994f.svg";